<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="PENDAFTARAN (IBVK)">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt2">
            <div class="xs6">
              <div class="spacer"></div>
              <div class="spacer"></div>
               <w-input
               v-model="pencarian.no_batch"
               label="No. Batch"
               />
            </div>
            <div class="xs6">
              <div class="spacer"></div>
               <z-select
               v-model="pencarian.se_katalog_id"
               :items="se_katalog"
               label="ID Ternakan"
               />
            </div>
            <!-- <div class="xs4">
               <z-select
               v-model="pencarian.status"
               :items="[
                 { value: 1, label: 'Aktif' },
                 { value: 2, label: 'Tidak Aktif' },
               ]"
               label="Status"
               />
            </div> -->
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
		  <z-table title="Senarai Pendaftaran (IBVK)" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.anyRole(['1', '3', '11'])">
                      <inertia-link :href="$route('embrio.pendaftaran.form',0)" v-on="on" class="w-button green--bg  w-button--dark size--md  ml1">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </inertia-link>
          </template>
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			     <!--  <w-icon xs>fal fa-pencil</w-icon> -->
           TINDAKAN
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
		        <inertia-link :href="$route('embrio.pendaftaran.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  PAPAR
            </inertia-link>
            &nbsp;
            <!-- <w-button  bg-color="info" v-if="item.hantar==1" @click="sijil(item.id)" class="be fs-2">
                <w-icon xs class="mr2">fal fa-certificate</w-icon> Sijil
              </w-button> -->
		      </w-flex>
          <br>
          <w-flex class="flex justify-center" v-if="$zutil.anyRole(['1', '3', '11'])">
            <w-button  bg-color="warning" v-if="item.hantar!=1" :route="$route('embrio.pendaftaran.form',item.id)" class="be fs-2">
              <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI 
            </w-button>
            &nbsp;
            <w-button class="fs-2" v-if="item.hantar!=1" bg-color="error-dark1" dark tile @click="destroy1(item.id)">
              <w-icon xs class="mr2">fal fa-trash</w-icon> PADAM
            </w-button>
          </w-flex>
		    </template>
        <template #item-cell.tarikh="{ item, label, header, index }">
          <w-flex class="flex justify-light">
            {{ $zutil.dateformat(item.tarikh)}}
          </w-flex>
        </template>
        <template #item-cell.tarikh_pengeluaran="{ item, label, header, index }">
          <w-flex class="flex justify-light">
            {{ $zutil.dateformat(item.tarikh_pengeluaran)}}
          </w-flex>
        </template>
		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'embrio.pendaftaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Pendaftaran (IBVK)', route: '/embrio/pendaftaran' },
      ],
      pencarian: {
         no_batch: '',
         se_katalog_id: '',
         // lkp_baka_id: ''
      },
      se_katalog: [],
      
    }
  },
  methods: {
    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },
    sijil(item){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('se.pendaftaran.sijil', item), '_blank');
    },
    generate(item){
      window.open( window.route('se.pendaftaran.qr', item), '_self');
    },
    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
  
  },

  watch: {

  },
  mounted() {
    this.getKatalog();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
